// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimelineFragment-module__font-s-10___E6UFr {
  font-size: 10px !important;
}

.TimelineFragment-module__font-s-12___d7jpA {
  font-size: 12px !important;
}

.TimelineFragment-module__font-s-13___SE3iQ {
  font-size: 13px !important;
}

.TimelineFragment-module__font-s-14___N3nOt {
  font-size: 14px !important;
}

.TimelineFragment-module__font-s-15___fS2xA {
  font-size: 15px !important;
}

.TimelineFragment-module__font-s-16___aCxUY {
  font-size: 16px !important;
}

.TimelineFragment-module__font-s-18___S5Zye {
  font-size: 18px !important;
}

.TimelineFragment-module__font-s-20___cOLLF {
  font-size: 20px !important;
}

.TimelineFragment-module__font-s-22___cn3hF {
  font-size: 22px !important;
}

.TimelineFragment-module__font-s-28___LKIGH {
  font-size: 28px !important;
}

.TimelineFragment-module__font-w-400___FOGWd {
  font-weight: 400 !important;
}

.TimelineFragment-module__font-w-500___O4nwl {
  font-weight: 500 !important;
}

.TimelineFragment-module__font-w-600___d20ba {
  font-weight: 600 !important;
}

.TimelineFragment-module__font-w-700___IbBhB {
  font-weight: 700 !important;
}

.TimelineFragment-module__p-5___AQ0tp {
  padding: 5px !important;
}

.TimelineFragment-module__p-12___TA7_o {
  padding: 12px !important;
}

.TimelineFragment-module__p-16___FM1Ed {
  padding: 16px !important;
}

.TimelineFragment-module__p-30___l7iiq {
  padding: 30px !important;
}

.TimelineFragment-module__p-b-0___tC_O0 {
  padding-bottom: 0 !important;
}

.TimelineFragment-module__p-b-5___iCtLq {
  padding-bottom: 5px !important;
}

.TimelineFragment-module__p-b-10___Uq5Lb {
  padding-bottom: 10px !important;
}

.TimelineFragment-module__p-b-12___xKPaO {
  padding-bottom: 12px !important;
}

.TimelineFragment-module__p-b-16___eulYl {
  padding-bottom: 16px !important;
}

.TimelineFragment-module__p-b-18___c5uhG {
  padding-bottom: 18px !important;
}

.TimelineFragment-module__p-b-20___azMcV {
  padding-bottom: 20px !important;
}

.TimelineFragment-module__p-b-25___eSvzD {
  padding-bottom: 25px !important;
}

.TimelineFragment-module__p-b-30___d4SAC {
  padding-bottom: 30px !important;
}

.TimelineFragment-module__p-b-50___eNcPO {
  padding-bottom: 50px !important;
}

.TimelineFragment-module__p-t-0___OoOQV {
  padding-top: 0 !important;
}

.TimelineFragment-module__p-t-12____RRLH {
  padding-top: 12px !important;
}

.TimelineFragment-module__p-t-16___CtCpd {
  padding-top: 16px !important;
}

.TimelineFragment-module__p-t-18___FFkjB {
  padding-top: 18px !important;
}

.TimelineFragment-module__p-t-20___touSK {
  padding-top: 20px !important;
}

.TimelineFragment-module__p-t-30___Cf8cT {
  padding-top: 30px !important;
}

.TimelineFragment-module__p-t-40___HpRlt {
  padding-top: 40px !important;
}

.TimelineFragment-module__p-t-50___J0Wai {
  padding-top: 50px !important;
}

.TimelineFragment-module__p-l-20___vQ2MV {
  padding-left: 20px !important;
}

.TimelineFragment-module__p-l-30___Xiie3 {
  padding-left: 30px !important;
}

.TimelineFragment-module__p-l-40___iCNQ2 {
  padding-left: 40px !important;
}

.TimelineFragment-module__p-r-16___XpNpV {
  padding-right: 16px !important;
}

.TimelineFragment-module__p-r-20___erSHB {
  padding-right: 20px !important;
}

.TimelineFragment-module__p-r-30___drK4c {
  padding-right: 30px !important;
}

.TimelineFragment-module__p-r-50___omBom {
  padding-right: 50px !important;
}

.TimelineFragment-module__p-r-60___J2Jqy {
  padding-right: 60px !important;
}

.TimelineFragment-module__m-b-1___UaQqs {
  margin-bottom: 1px !important;
}

.TimelineFragment-module__m-b-2___QjwuO {
  margin-bottom: 2px !important;
}

.TimelineFragment-module__m-b-6___QYNwY {
  margin-bottom: 6px !important;
}

.TimelineFragment-module__m-b-8___PgeGs {
  margin-bottom: 8px !important;
}

.TimelineFragment-module__m-b-10___tImFs {
  margin-bottom: 10px !important;
}

.TimelineFragment-module__m-b-14___OGYwC {
  margin-bottom: 14px !important;
}

.TimelineFragment-module__m-b-16___H_1pn {
  margin-bottom: 16px !important;
}

.TimelineFragment-module__m-b-20___YfcXO {
  margin-bottom: 20px !important;
}

.TimelineFragment-module__m-b-22___f0RU6 {
  margin-bottom: 22px !important;
}

.TimelineFragment-module__m-b-24___JVQrd {
  margin-bottom: 24px !important;
}

.TimelineFragment-module__m-b-30___zh5Wd {
  margin-bottom: 30px !important;
}

.TimelineFragment-module__m-b-32___rH1dL {
  margin-bottom: 32px !important;
}

.TimelineFragment-module__m-b-40___UPWc1 {
  margin-bottom: 40px !important;
}

.TimelineFragment-module__m-t-2___EtXcd {
  margin-top: 2px !important;
}

.TimelineFragment-module__m-t-3___UuzhP {
  margin-top: 3px !important;
}

.TimelineFragment-module__m-t-4___t5yHO {
  margin-top: 4px !important;
}

.TimelineFragment-module__m-t-5___o1h64 {
  margin-top: 5px !important;
}

.TimelineFragment-module__m-t-8___Ot7f0 {
  margin-top: 8px !important;
}

.TimelineFragment-module__m-t-10___CP84X {
  margin-top: 10px !important;
}

.TimelineFragment-module__m-t-15___b2Hy5 {
  margin-top: 15px !important;
}

.TimelineFragment-module__m-t-16___TFEx3 {
  margin-top: 16px !important;
}

.TimelineFragment-module__m-t-20___JWpuJ {
  margin-top: 20px !important;
}

.TimelineFragment-module__m-t-22___c8wlf {
  margin-top: 22px !important;
}

.TimelineFragment-module__m-t-30___BCzAD {
  margin-top: 30px !important;
}

.TimelineFragment-module__m-t-32___mo4B2 {
  margin-top: 32px !important;
}

.TimelineFragment-module__m-l-auto___Ti2iM {
  margin-left: auto !important;
}

.TimelineFragment-module__m-l-4___QwrVI {
  margin-left: 4px !important;
}

.TimelineFragment-module__m-l-5___LdJuR {
  margin-left: 5px !important;
}

.TimelineFragment-module__m-l-6___favtZ {
  margin-left: 6px !important;
}

.TimelineFragment-module__m-l-8___fE9Yf {
  margin-left: 8px !important;
}

.TimelineFragment-module__m-l-10___DK5tL {
  margin-left: 10px !important;
}

.TimelineFragment-module__m-l-16___WzIC2 {
  margin-left: 16px !important;
}

.TimelineFragment-module__m-l-20___Gd6lh {
  margin-left: 20px !important;
}

.TimelineFragment-module__m-l-24___nc9QH {
  margin-left: 24px !important;
}

.TimelineFragment-module__m-l-30___x4fVW {
  margin-left: 30px !important;
}

.TimelineFragment-module__m-l-35___rf532 {
  margin-left: 35px !important;
}

.TimelineFragment-module__m-l-40___hvtQE {
  margin-left: 40px !important;
}

.TimelineFragment-module__m-r-8___spqf9 {
  margin-right: 8px !important;
}

.TimelineFragment-module__m-r-10___lGzz9 {
  margin-right: 10px !important;
}

.TimelineFragment-module__m-r-16___rt7f5 {
  margin-right: 16px !important;
}

.TimelineFragment-module__m-r-20___jIDCp {
  margin-right: 20px !important;
}

.TimelineFragment-module__m-r-24___jSqGi {
  margin-right: 24px !important;
}

.TimelineFragment-module__m-r-30___J5buG {
  margin-right: 30px !important;
}

.TimelineFragment-module__m-r-40___Ccrgz {
  margin-right: 40px !important;
}

.TimelineFragment-module__border-r-3___BwXmk {
  border-radius: 3px !important;
}

.TimelineFragment-module__border-r-4___dgpAW {
  border-radius: 4px !important;
}

.TimelineFragment-module__border-r-6___QW0QN {
  border-radius: 6px !important;
}

.TimelineFragment-module__border-r-10___DK4HF {
  border-radius: 10px !important;
}

.TimelineFragment-module__border-r-12___PMmpg {
  border-radius: 12px !important;
}

.TimelineFragment-module__border-r-16___pWkx4 {
  border-radius: 16px !important;
}

.TimelineFragment-module__border-r-50___LtTEg {
  border-radius: 50% !important;
}

.TimelineFragment-module__primary-border___x0Hh2 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TimelineFragment-module__primary-border-b___keEk4 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TimelineFragment-module__primary-border-t___nxC0w {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TimelineFragment-module__primary-border-l___SQ81z {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TimelineFragment-module__primary-border-r___MPT8L {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TimelineFragment-module__secondary-border___uuJDR {
  border: 1px solid #637768;
}

.TimelineFragment-module__secondary-border-b___hDEFv {
  border-bottom: 1px solid #637768;
}

.TimelineFragment-module__secondary-border-t___Aw0j1 {
  border-top: 1px solid #637768;
}

.TimelineFragment-module__secondary-border-l___L817t {
  border-left: 1px solid #637768;
}

.TimelineFragment-module__secondary-border-r___y_J4i {
  border-right: 1px solid #637768;
}

.TimelineFragment-module__gap-0___lV5iS {
  gap: 0 !important;
}

.TimelineFragment-module__gap-2___tG0ak {
  gap: 2px !important;
}

.TimelineFragment-module__gap-4___Ejo_I {
  gap: 4px !important;
}

.TimelineFragment-module__gap-5___vdVQ4 {
  gap: 5px !important;
}

.TimelineFragment-module__gap-6___XFsOG {
  gap: 6px !important;
}

.TimelineFragment-module__gap-8___pUOW_ {
  gap: 8px !important;
}

.TimelineFragment-module__gap-10____UY5a {
  gap: 10px !important;
}

.TimelineFragment-module__gap-12___YaeJ1 {
  gap: 12px !important;
}

.TimelineFragment-module__gap-14___BO1wj {
  gap: 14px !important;
}

.TimelineFragment-module__gap-16___p4y6K {
  gap: 16px !important;
}

.TimelineFragment-module__gap-18___JeG_5 {
  gap: 18px !important;
}

.TimelineFragment-module__gap-20___wJ4vG {
  gap: 20px !important;
}

.TimelineFragment-module__gap-24___8hgOl {
  gap: 24px !important;
}

.TimelineFragment-module__gap-26___Q4vT_ {
  gap: 26px !important;
}

.TimelineFragment-module__gap-30___vgMZU {
  gap: 30px !important;
}

.TimelineFragment-module__gap-32___ExPgZ {
  gap: 32px !important;
}

.TimelineFragment-module__gap-40___VWRFd {
  gap: 40px !important;
}

.TimelineFragment-module__gap-50___W8Ty3 {
  gap: 50px !important;
}

.TimelineFragment-module__flex-1___KeTr3 {
  flex: 1;
}

.TimelineFragment-module__flex-none___RcQz9 {
  flex: none !important;
}

.TimelineFragment-module__flex-column___jBTXE {
  display: flex;
  flex-direction: column !important;
}

.TimelineFragment-module__flex-row___P1G1g {
  display: flex;
  flex-direction: row !important;
}

.TimelineFragment-module__vertically-centered___iyHZY {
  display: flex;
  align-items: center !important;
}

.TimelineFragment-module__horizontally-centered___RJrPn {
  display: flex;
  justify-content: center !important;
}

.TimelineFragment-module__horizontally-end___BFP9E {
  display: flex;
  justify-content: end !important;
}

.TimelineFragment-module__vertically-start___DQXcB {
  display: flex;
  align-items: start !important;
}

.TimelineFragment-module__space-between___y3JUc {
  display: flex;
  justify-content: space-between !important;
}

.TimelineFragment-module__flex-wrap___teNX_ {
  flex-wrap: wrap !important;
}

.TimelineFragment-module__height-100___fNJNZ {
  height: 100%;
}

.TimelineFragment-module__width-50___gK_pT {
  width: 50% !important;
}

.TimelineFragment-module__width-100___pqN5e {
  width: 100%;
}

.TimelineFragment-module__cursor-pointer___sQ2TB {
  cursor: pointer;
}

.TimelineFragment-module__cursor-not-allowed___7ruhc {
  cursor: not-allowed !important;
}

.TimelineFragment-module__absolute-centered___I8Erg {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TimelineFragment-module__absolute___PQxIY {
  position: absolute;
}

.TimelineFragment-module__relative___kBXHl {
  position: relative;
}

.TimelineFragment-module__fixed___tm8tU {
  position: fixed;
}

.TimelineFragment-module__visible___E6Qgv {
  opacity: 1;
}

.TimelineFragment-module__invisible___onjRY {
  opacity: 0;
}

.TimelineFragment-module__col-90___MjR57 {
  width: 90% !important;
}

.TimelineFragment-module__col-auto___lumVy {
  width: auto !important;
}

.TimelineFragment-module__medical-tabs___Wz00c {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TimelineFragment-module__medical-table-new___rKxMS {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TimelineFragment-module__medical-table-new___rKxMS:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TimelineFragment-module__medical-table-new___rKxMS::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TimelineFragment-module__medical-table-new___rKxMS::-webkit-scrollbar-track {
  display: none;
}
.TimelineFragment-module__medical-table-new___rKxMS.TimelineFragment-module__no-pagination___cQ_lG {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TimelineFragment-module__medical-table-new___rKxMS.TimelineFragment-module__no-pagination___cQ_lG:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TimelineFragment-module__medical-table-new___rKxMS.TimelineFragment-module__no-pagination___cQ_lG::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TimelineFragment-module__medical-table-new___rKxMS.TimelineFragment-module__no-pagination___cQ_lG::-webkit-scrollbar-track {
  display: none;
}

.TimelineFragment-module__medical-table-empty___PKaTq {
  padding: 14px 40px !important;
}

.TimelineFragment-module__icon-btn___lksBW {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TimelineFragment-module__search-icon___HKxQW {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TimelineFragment-module__disable-select___WP3Mt {
  user-select: none;
}

.TimelineFragment-module__break-word___aZGba {
  word-break: break-word;
}

.TimelineFragment-module__popup-clear-btn___Uj70n {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TimelineFragment-module__scroll-m-b-20___yx53T {
  scroll-margin-bottom: 20px;
}

.TimelineFragment-module__container___t5TQS {
  padding: 2em 0 1em 0;
  overflow: hidden;
  overflow-y: scroll;
  height: calc(100vh - 130px - var(--top-navigation) - var(--patient-details-header));
  position: relative;
  margin-bottom: 130px;
}
.TimelineFragment-module__container___t5TQS .TimelineFragment-module__progress___ZQdKc {
  left: 50%;
  position: absolute;
  top: 0;
}
.TimelineFragment-module__container___t5TQS .TimelineFragment-module__empty___lc8ZU {
  font-family: var(--font-family);
  font-weight: 700;
  font-size: 24px;
  color: #929292;
  margin: auto;
}
.TimelineFragment-module__container___t5TQS .TimelineFragment-module__separator___nEOai {
  text-transform: uppercase;
}
.TimelineFragment-module__container___t5TQS .TimelineFragment-module__button___zUgdr {
  background-color: #375844;
  flex-direction: row;
  border-radius: 6px;
  padding: 5px 10px;
  position: sticky;
  margin: 0 auto;
  bottom: 10px;
  width: auto;
}
.TimelineFragment-module__container___t5TQS .TimelineFragment-module__button___zUgdr > span {
  color: white;
  font-size: 16px !important;
}
.TimelineFragment-module__container___t5TQS .TimelineFragment-module__button___zUgdr > img {
  width: 22px;
  height: 22px;
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(120%) contrast(102%);
}
.TimelineFragment-module__container___t5TQS .TimelineFragment-module__bottom___G9sV0 {
  width: 1px;
  height: 1px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/TimelineFragment/TimelineFragment.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mFAAA;EACA,kBAAA;EACA,oBAAA;AA8pBF;AA5pBE;EACE,SAAA;EACA,kBAAA;EACA,MAAA;AA8pBJ;AA3pBE;EEUA,+BApBO;EAqBP,gBCtBK;EHaH,eAAA;EACA,cAAA;EACA,YAAA;AA8pBJ;AA3pBE;EACE,yBAAA;AA6pBJ;AA1pBE;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;AA4pBJ;AA1pBI;EACE,YAAA;EACA,0BAAA;AA4pBN;AAzpBI;EACE,WAAA;EACA,YAAA;EACA,gGAAA;AA2pBN;AAtpBE;EACE,UAAA;EACA,WAAA;AAwpBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  padding: 2em 0 1em 0;\n  overflow: hidden;\n  overflow-y: scroll;\n  height: calc(100vh - 130px - var(--top-navigation) - var(--patient-details-header));\n  position: relative;\n  margin-bottom: 130px;\n\n  .progress {\n    left: 50%;\n    position: absolute;\n    top: 0;\n  }\n\n  .empty {\n    @include get-font($roboto, $bold);\n    font-size: 24px;\n    color: #929292;\n    margin: auto;\n  }\n\n  .separator {\n    text-transform: uppercase;\n  }\n\n  .button {\n    background-color: get-color(greenNew, dark);\n    flex-direction: row;\n    border-radius: 6px;\n    padding: 5px 10px;\n    position: sticky;\n    margin: 0 auto;\n    bottom: 10px;\n    width: auto;\n\n    & > span {\n      color: get-color(white);\n      font-size: 16px !important;\n    }\n\n    & > img {\n      width: 22px;\n      height: 22px;\n      filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(120%)\n        contrast(102%);\n    }\n  }\n\n  .bottom {\n    width: 1px;\n    height: 1px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TimelineFragment-module__font-s-10___E6UFr`,
	"fontS12": `TimelineFragment-module__font-s-12___d7jpA`,
	"fontS13": `TimelineFragment-module__font-s-13___SE3iQ`,
	"fontS14": `TimelineFragment-module__font-s-14___N3nOt`,
	"fontS15": `TimelineFragment-module__font-s-15___fS2xA`,
	"fontS16": `TimelineFragment-module__font-s-16___aCxUY`,
	"fontS18": `TimelineFragment-module__font-s-18___S5Zye`,
	"fontS20": `TimelineFragment-module__font-s-20___cOLLF`,
	"fontS22": `TimelineFragment-module__font-s-22___cn3hF`,
	"fontS28": `TimelineFragment-module__font-s-28___LKIGH`,
	"fontW400": `TimelineFragment-module__font-w-400___FOGWd`,
	"fontW500": `TimelineFragment-module__font-w-500___O4nwl`,
	"fontW600": `TimelineFragment-module__font-w-600___d20ba`,
	"fontW700": `TimelineFragment-module__font-w-700___IbBhB`,
	"p5": `TimelineFragment-module__p-5___AQ0tp`,
	"p12": `TimelineFragment-module__p-12___TA7_o`,
	"p16": `TimelineFragment-module__p-16___FM1Ed`,
	"p30": `TimelineFragment-module__p-30___l7iiq`,
	"pB0": `TimelineFragment-module__p-b-0___tC_O0`,
	"pB5": `TimelineFragment-module__p-b-5___iCtLq`,
	"pB10": `TimelineFragment-module__p-b-10___Uq5Lb`,
	"pB12": `TimelineFragment-module__p-b-12___xKPaO`,
	"pB16": `TimelineFragment-module__p-b-16___eulYl`,
	"pB18": `TimelineFragment-module__p-b-18___c5uhG`,
	"pB20": `TimelineFragment-module__p-b-20___azMcV`,
	"pB25": `TimelineFragment-module__p-b-25___eSvzD`,
	"pB30": `TimelineFragment-module__p-b-30___d4SAC`,
	"pB50": `TimelineFragment-module__p-b-50___eNcPO`,
	"pT0": `TimelineFragment-module__p-t-0___OoOQV`,
	"pT12": `TimelineFragment-module__p-t-12____RRLH`,
	"pT16": `TimelineFragment-module__p-t-16___CtCpd`,
	"pT18": `TimelineFragment-module__p-t-18___FFkjB`,
	"pT20": `TimelineFragment-module__p-t-20___touSK`,
	"pT30": `TimelineFragment-module__p-t-30___Cf8cT`,
	"pT40": `TimelineFragment-module__p-t-40___HpRlt`,
	"pT50": `TimelineFragment-module__p-t-50___J0Wai`,
	"pL20": `TimelineFragment-module__p-l-20___vQ2MV`,
	"pL30": `TimelineFragment-module__p-l-30___Xiie3`,
	"pL40": `TimelineFragment-module__p-l-40___iCNQ2`,
	"pR16": `TimelineFragment-module__p-r-16___XpNpV`,
	"pR20": `TimelineFragment-module__p-r-20___erSHB`,
	"pR30": `TimelineFragment-module__p-r-30___drK4c`,
	"pR50": `TimelineFragment-module__p-r-50___omBom`,
	"pR60": `TimelineFragment-module__p-r-60___J2Jqy`,
	"mB1": `TimelineFragment-module__m-b-1___UaQqs`,
	"mB2": `TimelineFragment-module__m-b-2___QjwuO`,
	"mB6": `TimelineFragment-module__m-b-6___QYNwY`,
	"mB8": `TimelineFragment-module__m-b-8___PgeGs`,
	"mB10": `TimelineFragment-module__m-b-10___tImFs`,
	"mB14": `TimelineFragment-module__m-b-14___OGYwC`,
	"mB16": `TimelineFragment-module__m-b-16___H_1pn`,
	"mB20": `TimelineFragment-module__m-b-20___YfcXO`,
	"mB22": `TimelineFragment-module__m-b-22___f0RU6`,
	"mB24": `TimelineFragment-module__m-b-24___JVQrd`,
	"mB30": `TimelineFragment-module__m-b-30___zh5Wd`,
	"mB32": `TimelineFragment-module__m-b-32___rH1dL`,
	"mB40": `TimelineFragment-module__m-b-40___UPWc1`,
	"mT2": `TimelineFragment-module__m-t-2___EtXcd`,
	"mT3": `TimelineFragment-module__m-t-3___UuzhP`,
	"mT4": `TimelineFragment-module__m-t-4___t5yHO`,
	"mT5": `TimelineFragment-module__m-t-5___o1h64`,
	"mT8": `TimelineFragment-module__m-t-8___Ot7f0`,
	"mT10": `TimelineFragment-module__m-t-10___CP84X`,
	"mT15": `TimelineFragment-module__m-t-15___b2Hy5`,
	"mT16": `TimelineFragment-module__m-t-16___TFEx3`,
	"mT20": `TimelineFragment-module__m-t-20___JWpuJ`,
	"mT22": `TimelineFragment-module__m-t-22___c8wlf`,
	"mT30": `TimelineFragment-module__m-t-30___BCzAD`,
	"mT32": `TimelineFragment-module__m-t-32___mo4B2`,
	"mLAuto": `TimelineFragment-module__m-l-auto___Ti2iM`,
	"mL4": `TimelineFragment-module__m-l-4___QwrVI`,
	"mL5": `TimelineFragment-module__m-l-5___LdJuR`,
	"mL6": `TimelineFragment-module__m-l-6___favtZ`,
	"mL8": `TimelineFragment-module__m-l-8___fE9Yf`,
	"mL10": `TimelineFragment-module__m-l-10___DK5tL`,
	"mL16": `TimelineFragment-module__m-l-16___WzIC2`,
	"mL20": `TimelineFragment-module__m-l-20___Gd6lh`,
	"mL24": `TimelineFragment-module__m-l-24___nc9QH`,
	"mL30": `TimelineFragment-module__m-l-30___x4fVW`,
	"mL35": `TimelineFragment-module__m-l-35___rf532`,
	"mL40": `TimelineFragment-module__m-l-40___hvtQE`,
	"mR8": `TimelineFragment-module__m-r-8___spqf9`,
	"mR10": `TimelineFragment-module__m-r-10___lGzz9`,
	"mR16": `TimelineFragment-module__m-r-16___rt7f5`,
	"mR20": `TimelineFragment-module__m-r-20___jIDCp`,
	"mR24": `TimelineFragment-module__m-r-24___jSqGi`,
	"mR30": `TimelineFragment-module__m-r-30___J5buG`,
	"mR40": `TimelineFragment-module__m-r-40___Ccrgz`,
	"borderR3": `TimelineFragment-module__border-r-3___BwXmk`,
	"borderR4": `TimelineFragment-module__border-r-4___dgpAW`,
	"borderR6": `TimelineFragment-module__border-r-6___QW0QN`,
	"borderR10": `TimelineFragment-module__border-r-10___DK4HF`,
	"borderR12": `TimelineFragment-module__border-r-12___PMmpg`,
	"borderR16": `TimelineFragment-module__border-r-16___pWkx4`,
	"borderR50": `TimelineFragment-module__border-r-50___LtTEg`,
	"primaryBorder": `TimelineFragment-module__primary-border___x0Hh2`,
	"primaryBorderB": `TimelineFragment-module__primary-border-b___keEk4`,
	"primaryBorderT": `TimelineFragment-module__primary-border-t___nxC0w`,
	"primaryBorderL": `TimelineFragment-module__primary-border-l___SQ81z`,
	"primaryBorderR": `TimelineFragment-module__primary-border-r___MPT8L`,
	"secondaryBorder": `TimelineFragment-module__secondary-border___uuJDR`,
	"secondaryBorderB": `TimelineFragment-module__secondary-border-b___hDEFv`,
	"secondaryBorderT": `TimelineFragment-module__secondary-border-t___Aw0j1`,
	"secondaryBorderL": `TimelineFragment-module__secondary-border-l___L817t`,
	"secondaryBorderR": `TimelineFragment-module__secondary-border-r___y_J4i`,
	"gap0": `TimelineFragment-module__gap-0___lV5iS`,
	"gap2": `TimelineFragment-module__gap-2___tG0ak`,
	"gap4": `TimelineFragment-module__gap-4___Ejo_I`,
	"gap5": `TimelineFragment-module__gap-5___vdVQ4`,
	"gap6": `TimelineFragment-module__gap-6___XFsOG`,
	"gap8": `TimelineFragment-module__gap-8___pUOW_`,
	"gap10": `TimelineFragment-module__gap-10____UY5a`,
	"gap12": `TimelineFragment-module__gap-12___YaeJ1`,
	"gap14": `TimelineFragment-module__gap-14___BO1wj`,
	"gap16": `TimelineFragment-module__gap-16___p4y6K`,
	"gap18": `TimelineFragment-module__gap-18___JeG_5`,
	"gap20": `TimelineFragment-module__gap-20___wJ4vG`,
	"gap24": `TimelineFragment-module__gap-24___8hgOl`,
	"gap26": `TimelineFragment-module__gap-26___Q4vT_`,
	"gap30": `TimelineFragment-module__gap-30___vgMZU`,
	"gap32": `TimelineFragment-module__gap-32___ExPgZ`,
	"gap40": `TimelineFragment-module__gap-40___VWRFd`,
	"gap50": `TimelineFragment-module__gap-50___W8Ty3`,
	"flex1": `TimelineFragment-module__flex-1___KeTr3`,
	"flexNone": `TimelineFragment-module__flex-none___RcQz9`,
	"flexColumn": `TimelineFragment-module__flex-column___jBTXE`,
	"flexRow": `TimelineFragment-module__flex-row___P1G1g`,
	"verticallyCentered": `TimelineFragment-module__vertically-centered___iyHZY`,
	"horizontallyCentered": `TimelineFragment-module__horizontally-centered___RJrPn`,
	"horizontallyEnd": `TimelineFragment-module__horizontally-end___BFP9E`,
	"verticallyStart": `TimelineFragment-module__vertically-start___DQXcB`,
	"spaceBetween": `TimelineFragment-module__space-between___y3JUc`,
	"flexWrap": `TimelineFragment-module__flex-wrap___teNX_`,
	"height100": `TimelineFragment-module__height-100___fNJNZ`,
	"width50": `TimelineFragment-module__width-50___gK_pT`,
	"width100": `TimelineFragment-module__width-100___pqN5e`,
	"cursorPointer": `TimelineFragment-module__cursor-pointer___sQ2TB`,
	"cursorNotAllowed": `TimelineFragment-module__cursor-not-allowed___7ruhc`,
	"absoluteCentered": `TimelineFragment-module__absolute-centered___I8Erg`,
	"absolute": `TimelineFragment-module__absolute___PQxIY`,
	"relative": `TimelineFragment-module__relative___kBXHl`,
	"fixed": `TimelineFragment-module__fixed___tm8tU`,
	"visible": `TimelineFragment-module__visible___E6Qgv`,
	"invisible": `TimelineFragment-module__invisible___onjRY`,
	"col90": `TimelineFragment-module__col-90___MjR57`,
	"colAuto": `TimelineFragment-module__col-auto___lumVy`,
	"medicalTabs": `TimelineFragment-module__medical-tabs___Wz00c`,
	"medicalTableNew": `TimelineFragment-module__medical-table-new___rKxMS`,
	"noPagination": `TimelineFragment-module__no-pagination___cQ_lG`,
	"medicalTableEmpty": `TimelineFragment-module__medical-table-empty___PKaTq`,
	"iconBtn": `TimelineFragment-module__icon-btn___lksBW`,
	"searchIcon": `TimelineFragment-module__search-icon___HKxQW`,
	"disableSelect": `TimelineFragment-module__disable-select___WP3Mt`,
	"breakWord": `TimelineFragment-module__break-word___aZGba`,
	"popupClearBtn": `TimelineFragment-module__popup-clear-btn___Uj70n`,
	"scrollMB20": `TimelineFragment-module__scroll-m-b-20___yx53T`,
	"container": `TimelineFragment-module__container___t5TQS`,
	"progress": `TimelineFragment-module__progress___ZQdKc`,
	"empty": `TimelineFragment-module__empty___lc8ZU`,
	"separator": `TimelineFragment-module__separator___nEOai`,
	"button": `TimelineFragment-module__button___zUgdr`,
	"bottom": `TimelineFragment-module__bottom___G9sV0`
};
module.exports = ___CSS_LOADER_EXPORT___;
